import success from '@/assets/images/success.svg';
import warning from '@/assets/images/warning.svg';
import fail from '@/assets/images/fail.svg';
import localization from '@/constant/localization';
import { currency, getFromLocalStorage, persianDateGenerator2, toMilliSecond } from '@/lib/helper';
import cn from '@/lib/clsxm';
import React, { useEffect } from 'react';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { SIZE_ENUM } from '@/components/@base/@types';
import { finalInvoiceResType } from '@/services/models/api.models';
import banner from '@/assets/images/ofogh-banner.jpg';
import { useGetAdvertisement } from '@/services/hooks';
import { useSearchParams } from 'react-router-dom';

const ReceiptCard = ({
  seconds,
  data,
  setDisableBtn,
  goToCommercialUrl,
}: {
  seconds: number;
  data: finalInvoiceResType;
  setDisableBtn: () => void;
  goToCommercialUrl: () => void;
}) => {
  const {
    amount,
    referenceCode,
    merchantBrandName,
    createDate,
    merchantRedirectURL,
    invoiceStatusId,
  } = data;
  const [searchParams] = useSearchParams();
  const pgc = searchParams.get('pgc') || getFromLocalStorage("pgc")
  const {data:advertise} = useGetAdvertisement(12, pgc as string)
  const statusChecker = () => {
    return (
      invoiceStatusId === 15 ||
      invoiceStatusId === 40 ||
      invoiceStatusId === 45 ||
      invoiceStatusId === 50
    );
  };
  const items = [
    {
      title: localization.dataAndTime,
      amount: createDate
        ? persianDateGenerator2(new Date(toMilliSecond(createDate)))
        : persianDateGenerator2(new Date()),
    },
    {
      title: localization.acceptor,
      amount: merchantBrandName,
    },
    {
      title: localization.issueTracking,
      amount: referenceCode,
    },
    {
      title: statusChecker() ? localization.totalAmountPaid : localization.invoiceTotalAmount,
      amount: amount,
    },
  ];
  const redirectAction = () => {
    if (merchantRedirectURL.length > 0) {
      window.location.assign(merchantRedirectURL);
    } else if (merchantRedirectURL.length === 0) {
      window.location.assign(
        'https://app.ozone.ir/c/campaigns/gift4friends?utm_source=billing&utm_medium=fx-bnr&utm_campaign=RC',
      );
    }
    setDisableBtn();
  };
  useEffect(() => {
    if (seconds === 0) redirectAction();
  }, [seconds]);
  return (
    <Container className='w-full px-4'>
      {data?.merchantRedirectURL.length === 0 && (
        <img
          src={banner}
          alt='commercial banner'
          className='mb-4 w-full cursor-pointer rounded-xl'
          onClick={goToCommercialUrl}
        />
      )}
      <Container
        center
        className={cn(
          'mx-auto w-full flex-col rounded-xl border',
          statusChecker() ? 'border-green-50 dark:border-green-900' : 'border-red-50 dark:border-red-900'
        )}
      >
        <Container center className={cn('relative w-full max-w-[420px] flex-col gap-1 pt-12 pb-5 rounded-t-xl',
          statusChecker() ? 'bg-green-50 dark:bg-green-900' : 'bg-red-50 dark:bg-red-900')}>
          <img
            src={statusChecker() ? success : merchantRedirectURL.length > 0 ? fail : warning}
            width={64}
            height={64}
            alt=''
          />

          <Text
            size={SIZE_ENUM.MD}
            medium
            className='text-grayLight-1000 dark:text-grayLight-0'
          >
            {statusChecker()
              ? localization.successfulTransaction
              : merchantRedirectURL.length > 0
                ? localization.transactionFailed
                : localization.refuseFromPayment}
          </Text>
          {merchantRedirectURL.length === 0 && !statusChecker() && (
            <Text size={SIZE_ENUM.SM} className='text-grayLight-500 dark:text-grayLight-0'>
              {localization.askForQRcode}
            </Text>
          )}
        </Container>
        <Container center className='w-full max-w-[420px] flex-col'>
          {items?.map((i, index) => (
            <Container
              center
              className={cn(
                'w-full justify-between border-b-[1px] border-grayLight-50 px-4 py-2 last:mb-0 last:rounded-b-xl last:border-none i5:p-4 dark:border-grayDark-750',
                !i.amount && 'hidden',
              )}
            >
              <Text medium size={SIZE_ENUM.SM} className={'dark:grayDark text-grayLight-600'}>
                {i.title}
              </Text>
              {index < 3 ? (
                <Text
                  medium
                  size={SIZE_ENUM.SM}
                  className={'text-grayLight-1000 dark:text-grayLight-0'}
                >
                  {i.amount}
                </Text>
              ) : (
                <Container center className='gap-1'>
                  <Text
                    medium
                    size={SIZE_ENUM.MD}
                    className={cn(
                      statusChecker() ? 'text-green dark:text-green-200' : 'text-red dark:text-red-200',
                      merchantRedirectURL.length === 0 &&
                        'text-grayLight-1000 dark:text-grayLight-0',
                    )}
                  >
                    {currency(+i.amount)}
                  </Text>
                  <Text
                    medium
                    size={SIZE_ENUM.XS}
                    className={cn(
                      statusChecker() ? 'text-green dark:text-green-200' : 'text-red dark:text-red-200',
                      merchantRedirectURL.length === 0 &&
                        'text-grayLight-1000 dark:text-grayLight-0',
                    )}
                  >
                    {localization.rial}
                  </Text>
                </Container>
              )}
            </Container>
          ))}
        </Container>
      </Container>
      {statusChecker() && advertise && advertise?.ads?.length > 0 && advertise?.ads[0]?.banner && advertise?.ads[0]?.banner?.length > 0 && (
        <Container className='mt-4'>
          <img
            src={advertise?.ads[0]?.banner}
            alt='ads'
            className={cn('min-h-10 w-full rounded-lg')}
          />
        </Container>
      )}
    </Container>
  );
};

export default ReceiptCard;
